import React, { useEffect } from 'react';
import { ItemForm } from '../../Components/Form';
import FormLayout from '../../Components/Layout/FormLayout';
import { NewItemIcon } from '../../Assets/Navigation/NavigationIcons';
import { t } from 'i18next';

const EditItem = ({ handleToast, idFromHeaderWrapper, ...props }) => {
  useEffect(() => {
    document.title = t('Items.edit_item');
  }, []);

  return (
    <FormLayout
      title={t('Items.items')}
      Icon={NewItemIcon}
      subtitle={t('common.edit')}
      closeUrl="/items"
      iconstyle="general_module_icon"
      layoutBoxClass="uiux-form-redesign"
    >
      <ItemForm
        type="edit"
        id={idFromHeaderWrapper ? idFromHeaderWrapper : props.match.params.id}
        handleToast={handleToast}
      />
    </FormLayout>
  );
};

export default EditItem;
